module.exports = __webpack_public_path__ + "img/logo-spfc.7e2421c8.svg";